<template>
    <div>
        <el-row >
            <el-col :span="6">
                <span style="font-size:12px;color:rgba(0, 0, 0, 0.7)">说明：该模块配置小程序首页轮播图展示，最多同时激活4张图片</span>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" icon="el-icon-plus" @click="openDialog()">新增</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" style="width: 100%;margin-top:20px" border>
            <el-table-column :resizable="false" type="index" label="序号" width="100" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 + pageSize * (pageNo - 1) }}</template>
            </el-table-column>
            <el-table-column prop="description" label="轮播图描述" :resizable="false" align="center"></el-table-column>
            <el-table-column prop="swiperUrl" label="缩略图" :resizable="false" align="center">
                <template slot-scope="scope">
                     <el-image style="width: 50px; height: 50px" :src="scope.row.swiperUrl" @click="openImg(scope.row.swiperUrl)"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="relationName" label="关联跳转" :resizable="false" align="center"></el-table-column>
            <el-table-column prop="clothesType" label="启用状态" :resizable="false" align="center">
                <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.inUse"
                                :active-value="1" 
	                            :inactive-value="0" 
                                @change="changeInUse(scope.row)"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                            </el-switch>
                        </template>
            </el-table-column>
            <el-table-column label="操作" :resizable="false" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteSwiper(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="新增配置" :visible.sync="addDialogVisible" width="33%" :before-close="handleToClose" :close-on-click-modal="false">
            <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
                <el-form-item label="描述内容" prop="swiperDescription">
                    <el-input v-model="addForm.swiperDescription" placeholder="请输入轮播图描述内容"></el-input>
                </el-form-item>
                <el-form-item label="轮播图" prop="swiperUrl">
                    <el-upload
                        class="avatar-uploader"
                        action
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :http-request="(param) => handleHttpRequest(param,index)"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="addForm.swiperUrl" :src="addForm.swiperUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                 <el-form-item label="关联服饰" prop="keyWord">
                     <el-select
                        v-model="addForm.keyWord" filterable remote
                         placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        :loading="loading">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取消</el-button>
                    <el-button type="primary" @click="submitForm()">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="轮播图" :visible.sync="imgDialogVisible" width="30%" :before-close="handleImgClose">
            <div class="check">
                <img  :src="openImgUrl" class="image"/> 
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
      return {
          uploadUrl: 'file/upload', //图片上传地址
          pageNo:1,
          pageSize: 10,
          activeName: 'first',
          tableData: [],
          options: [],
          addDialogVisible: false,
          imgDialogVisible: false,
          openImgUrl: '',
          loading: false,
          addForm: {
                swiperDescription: '',
                swiperUrl: '',
                keyWord: ''
          },
            rules: {
                 swiperDescription: [
                     { required: true, message: '请输入轮播图描述内容', trigger: 'blur' }
                 ],
                 swiperUrl: [
                      { required: true, message: '请上传轮播图图片', trigger: 'change' }
                 ]
            }
      }
    },
    created() {
        this.getSwiperList()
    },
    methods: {
        async getSwiperList(){
            const res = await this.$axios.post('manage/config/getSwiperList')
            if(res.data.code == 0){
                this.tableData = res.data.data
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        openDialog() {
            this.addDialogVisible= true;
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.addDialogVisible = false;
                    that.resetForm()
                })
                .catch(() => {});
            // 重置表单
        },
        resetForm() {
            this.addForm = {
                swiperDescription: '',
                swiperUrl: '',
                keyWord: ''
            }
            this.options = []
        },
        submitForm() {
            let that = this;
            that.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('manage/config/addSwiper', {
                            description: that.addForm.swiperDescription, 
                            swiperUrl: that.addForm.swiperUrl, 
                            keyWord: that.addForm.keyWord
                        })
                        .then(res => {
                            if (res.data.code == 0) {
                                that.$message.success('新增成功');
                                that.addDialogVisible = false;
                                that.resetForm();
                                that.getSwiperList()
                            } else {
                                that.$message.error(res.data.data);
                            }
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        async changeInUse(row){
            const res = await this.$axios.post('manage/config/startStopSwiper',{
                id: row.id,
                status: row.inUse
            });
            if (res.data.code == 0) {
                this.$message.success(res.data.data);
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
         handleAvatarSuccess(res, file) {
        },
         beforeAvatarUpload(file) { 
        },
         //上传事件
        async handleHttpRequest(param,index) {
            const formData = new FormData();
            formData.append('file', param.file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(this.uploadUrl, formData, config);
            if (res.data.code == 0) {
                this.addForm.swiperUrl = res.data.data.url
            } else {
                this.$message.error(res.data);
            }
        },
         async deleteSwiper(id) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .get('manage/config/deleteSwiper', {
                        params : {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getSwiperList();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    })
                    .catch(() => {
                        this.getSwiperList();
                    });
            });
        },
        async remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                const res = await this.$axios.post('manage/cloth/searchClothesByKeyWord',{
                    keyWord: query
                });
                this.loading = false;
                if(res.data.code == 0){
                    this.options = res.data.data
                }else{
                    this.options = [];
                }
            } else {
                this.options = [];
            }
        },
        openImg(imgUrl) {
            this.openImgUrl = imgUrl
            this.imgDialogVisible = true;
        },
        handleImgClose() {
            this.imgDialogVisible = false;
        }
    }
}
</script>

<style>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}

</style>